import type { HTMLAttributes, ReactNode } from 'react'
import { Text, csx } from '@vtex/admin-ui'
import React from 'react'

import { ScheduleDeliveryButton } from './ScheduleDelivery'
import type { Package } from '../../../../../../core/typings'

export type DetailsBlockTemplateProps = {
  icon: ReactNode
  title: string
  details: string | ReactNode
  currentPackage?: Package
} & HTMLAttributes<HTMLDivElement>

export const DetailsBlockTemplate = ({
  icon,
  details,
  title,
  currentPackage,
  ...props
}: DetailsBlockTemplateProps) => (
  <div
    className={csx({
      background: '$gray05',
      paddingX: '$space-4',
      paddingY: '$space-3',
      marginTop: '$space-5',
      borderRadius: 4,
    })}
    {...props}
  >
    <div
      className={csx({
        display: 'flex',
        justifyContent: 'space-between',
      })}
    >
      <div
        className={csx({
          display: 'flex',
          alignItems: 'center',
        })}
      >
        <div className={csx({ marginRight: '$space-4' })}>{icon}</div>
        <Text
          className={csx({
            justifyContent: 'space-between',
            alignItems: 'center',
          })}
        >
          <Text variant="action1">{title}</Text>
          <Text variant="detail">{details}</Text>
        </Text>
      </div>
      <ScheduleDeliveryButton selectedPackage={currentPackage} />
    </div>
  </div>
)
